import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import { AdminDetails, AssistantDetails, BaseAssigned, LabAssistantDetails, LabObj2, LabObj3, SourceDetails, surveyorDetails, updateSurveyorDetails, VillageDetails } from '../models/models';
import { BehaviorSubject } from 'rxjs';
import { ShowToastService } from './show-toast.service';
import { ActiveComponent } from '../enums/access.type';
import { CookieService } from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root'
})
export class GetDataService {

  constructor(private http:HttpClient,private toastService:ShowToastService,private cookieService:CookieService){

  }
  
  private _username = new BehaviorSubject<any>(localStorage.getItem('mati_su_username'));
  private _baseAssigned = new BehaviorSubject<BaseAssigned[]>([]);
  private _currentBase = new BehaviorSubject<{id:number,name:string}>({id:-1,name:''});
  searchValue = new BehaviorSubject<string>("");

  searchBarPlaceholder = new BehaviorSubject<string>("");

  componentType = new BehaviorSubject<ActiveComponent>(ActiveComponent.Admin);

  getUsername = () =>{
    const username = this._username.asObservable();
    return username;
  }

  setUsername = (value:string) =>{
    this._username.next(value);
  }

  getRestApiConnection() {
    return (environment.baseUrl);
  }

  getBaseAssigned = ()=>{
    return this._baseAssigned.asObservable();
  }
  
  setBaseAssigned = (baseAssigned:BaseAssigned[])=>{
    this._baseAssigned.next(baseAssigned);
  }

  getCurrentBase = ()=>{
    return this._currentBase.asObservable();
  }
  setCurrentBase(currentBase:{id:number,name:string}){
    this._currentBase.next(currentBase);
  }

  checkIfSuperAdmin =(email:string)=>{
    let params = new HttpParams();
    params = params.append('email', email);
    return this.http.get<any>(this.getRestApiConnection() + '/auth/checkIfSuperAdmin',{params: params});
  }


  getAdminDetails = (search?:string) =>{
    let params = new HttpParams();
    if(search && search.length>0){
      params = params.append('search', search);
    }
    return this.http.get<any>(this.getRestApiConnection() + '/admin/getAdminDetails',{params:params});
  }

  addAdmin = (adminDetails: AdminDetails) =>{
    let req = adminDetails;
    req.user_type = 'fr';
    console.log('add admin---',req);
    return this.http.post<any>(this.getRestApiConnection() + '/admin/createAdmin',req);
  }

  updateAdmin = (adminDetails: AdminDetails) =>{
    const req = adminDetails;
    return this.http.patch<any>(this.getRestApiConnection() + '/admin/updateAdmin',req);
  }

  deleteAdmin = (phoneNo: string) =>{
    const req = {
      phone_no:phoneNo
    };
    return this.http.patch<any>(this.getRestApiConnection() + '/admin/deleteAdmin',req);
  }



  getSurveyorsList = (appType:1|2,search?:string) =>{
    // appType 1 for farmapp and appType 2 for warehouse
    let params = new HttpParams();
    if(search && search.length>0){
      params = params.append('search', search);
    }
    params = params.append('app_type', appType);
    return this.http.get<any>(this.getRestApiConnection() + '/farm/getSurveyorsList',{params:params});
  }

  getAllVillageList = (search?:string,state?:string[],district?:string[],block?:string[],panchayat?:string[]) =>{
    let params = new HttpParams();
    params = state && state.length>0?params.append('state', JSON.stringify(state)):params;
    params = district&& district.length>0?params.append('district', JSON.stringify(district)):params;
    params = block&& block.length>0?params.append('block',JSON.stringify(block) ):params;
    params = panchayat&& panchayat.length>0?params.append('panchayat', JSON.stringify(panchayat)):params;
    if(search && search.length>0){
      params = params.append('search', search);
    }
    return this.http.get<any>(this.getRestApiConnection() + '/farm/getAllVillageList',{params:params});
  }

  addVillage = (villageDetail: VillageDetails) =>{
    const req = villageDetail;
    return this.http.post<any>(this.getRestApiConnection() + '/farm/addVillage',req);
  }

  addSurveyor = (surveyorDetail: surveyorDetails) =>{
    const req = surveyorDetail;
    return this.http.post<any>(this.getRestApiConnection() + '/farm/createSurveyor',req);
  }

  updateSurveyor = (surveyorDetail: updateSurveyorDetails) => {
    const req = surveyorDetail;
    return this.http.patch<any>(this.getRestApiConnection() + '/farm/editSurveyor',req);
  }


  deleteSurveyor = (phoneNo: string) =>{
    const req = {
      phone_no:phoneNo
    };
    return this.http.patch<any>(this.getRestApiConnection() + '/farm/deleteSurveyor',req);
  }

  addAssistant = (assistantDetails:AssistantDetails) =>{
    const req = assistantDetails;
    return this.http.post<any>(this.getRestApiConnection() + '/warehouse/createAssistant',req);
  }

  getSourcesData = (search?:string,state?:string[],district?:string[],block?:string[],village?:string[],status?:string[]) =>{
    const token:any = localStorage.getItem('matiSuperAdminToken')
    const headers =  new HttpHeaders({ 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
   });
    let params = new HttpParams();
    params = status && status.length>0?params.append('status', JSON.stringify(status)):params;
    params = state && state.length>0?params.append('state', JSON.stringify(state)):params;
    params = district&& district.length>0?params.append('district', JSON.stringify(district)):params;
    params = block&& block.length>0?params.append('block',JSON.stringify(block) ):params;
    params = village&& village.length>0?params.append('village', JSON.stringify(village)):params;
    params = search?params.append('search', search):params;
    return this.http.get<any>(this.getRestApiConnection() + '/warehouse/getSourcesData',{params:params,headers:headers});
  }

  addSource= (sourceDetails: SourceDetails) =>{
    const req = sourceDetails;
    return this.http.post<any>(this.getRestApiConnection() + '/warehouse/addSource',req);
  }


  getSurveyorDetails = (phoneNo:string) =>{
    let params = new HttpParams();
    params = params.append('phone_no', phoneNo);
    return this.http.get<any>(this.getRestApiConnection() + '/farm/getSurveyorDetails',{params:params});
  }
  
  getBasesList=(search?:string)=>{
    let params = new HttpParams();
    if(search && search.length>0){
      params = params.append('search', search);
    }
    return this.http.get<any>(this.getRestApiConnection() + '/baseAdmin/getBasesList',{params:params});
  }

  updateCurrentBase=(currentBaseId:number)=>{
    const req= {
      current_base_id:currentBaseId
    };
    return this.http.patch<any>(this.getRestApiConnection() + '/admin/updateCurrentBase',req);
  }

  baseDetails=()=>{
    return this.http.get<any>(this.getRestApiConnection() + '/admin/baseDetails');
  }

  errorHandling = (errorMessage:string)=>{
    this.toastService.failure("",errorMessage);
  }

  backendError = "Something wrong, please try again later";



  getAssignedBases=()=>{
    const assignedBase = this.cookieService.get('assignedBase');;
    console.log('get base assgiend',assignedBase);
    if(assignedBase){
      const assignedBase_= JSON.parse(assignedBase);
      this.setBaseAssigned(assignedBase_);
      const currentBase = this.cookieService.get('currentBase');
      if(currentBase){
        this.setCurrentBase(JSON.parse(currentBase));
      }
    }
    else{
      this.baseDetails().subscribe(response=>{
        console.log('get assigned bases',response);
        if(response && response.status_code && response.status_code ==200 && response.data && response.data.result){
          const baseAssigned = response.data.result;
          const baseAssignedList = baseAssigned.map((item:any)=>{
            return {
              baseId:item.id,
              baseName:item.base_name
            }
          });
          const currentBaseId = response.data.current_base?response.data.current_base:-1;
          const index = baseAssignedList.findIndex((item:any)=>item.baseId == currentBaseId);
          console.log('get assigned bases2',currentBaseId,baseAssignedList);
          if(index != -1){
            const currentBaseName:string = baseAssignedList[index].baseName;
            this.setCurrentBase({id:currentBaseId,name:currentBaseName});
          }
          const baseAssignedValue = JSON.stringify(baseAssignedList)
          this.cookieService.set('assignedBase',baseAssignedValue);
          this.setBaseAssigned(baseAssignedList);
        }
        else{
          this.setBaseAssigned([]);
        }
      },error=>{
        this.setBaseAssigned([]);
      })
    }
  }

  getLabs=(search?:string)=>{
    let params = new HttpParams();
    if(search && search.length>0){
      params = params.append('search', search);
    }
    return this.http.get<any>(this.getRestApiConnection() + '/lab/listing',{params:params});
  }
  getLabAssistants=(search?:string)=>{
    let params = new HttpParams();
    if(search && search.length>0){
      params = params.append('search', search);
    }
    return this.http.get<any>(this.getRestApiConnection() + '/lab/assistantListing',{params:params});
  }

  createLab=(labObj:LabObj2)=>{
    return this.http.post<any>(this.getRestApiConnection() + '/lab/',labObj);
  }
  updateLab=(labObj:LabObj3)=>{
    return this.http.patch<any>(this.getRestApiConnection() + '/lab/details',labObj);
  }

  createLabAssistant=(assistantObj:LabAssistantDetails)=>{
    return this.http.post<any>(this.getRestApiConnection() + '/lab/assistant',assistantObj);
  }
  updateLabAssistant=(assistantObj:LabAssistantDetails)=>{
    return this.http.patch<any>(this.getRestApiConnection() + '/lab/assistantDetails',assistantObj);
  }

  deleteLab=(id:string)=>{
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.delete<any>(this.getRestApiConnection() + '/lab/details',{params:params});
  }
  deleteLabAssistant=(phoneNo:string)=>{
    let params = new HttpParams();
    params = params.append('phone_no', phoneNo);
    return this.http.delete<any>(this.getRestApiConnection() + '/lab/assistantDetails',{params:params});
  }
}